/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import './styles.scss'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import 'react-tippy/dist/tippy.css'
import { Tooltip } from 'react-tippy'
import Img from 'react-cool-img'

const isMobile = window.innerWidth < 769

export class AppComponent extends React.Component<Props, State> {
  constructor(props) {
    super(props)
    this.state = {
      activeHighlight: -1
    }
  }

  setActiveHighlight(id) {
    this.setState({
      activeHighlight: id
    })
  }

  render() {
    return (
      <div className='index'>
        <ThemeSwitch />
        <div className='ui' style={{ position: 'relative' }}>
          <img
            src={require('../../images/karte.jpg')}
            className='ui fluid image'
          />

          <div className='hint'>
            <i className='icon hand pointer outline' />
            {isMobile
              ? 'Tippen Sie auf die blauen Punkte'
              : 'Klicken Sie auf die blauen Punkte'}
          </div>

          <Tooltip
            html={
              <span>
                <h3>Franz Fischer</h3>
                <h2>Läufer</h2>
                <p>
                  <i className='bullseye icon' />
                  Heidgraben bei Spielwiese Oerlikon
                </p>
                <Img
                  placeholder={require('../../images/loading.gif')}
                  src={require('../../images/01.jpg')}
                  style={{
                    position: 'relative'
                  }}
                />
              </span>
            }
            position='bottom'
            size='small'
            arrow
            trigger='click'
            style={{
              position: 'absolute',
              zIndex: '99999',
              top: '31.3%',
              left: '49%'
            }}
            className={this.state.activeHighlight === 1 ? 'active' : 'inactive'}
            onShown={() => this.setActiveHighlight(1)}
            onHide={() => this.setActiveHighlight(-1)}
          >
            <div className='highlight' style={{ zIndex: '9' }} />
          </Tooltip>

          <Tooltip
            html={
              <span>
                <h3>Carl Leonhard Fischer</h3>
                <h2>Kugelwerfer</h2>
                <p>
                  <i className='bullseye icon' />
                  Schulhaus Milchbuck
                </p>
                <Img
                  placeholder={require('../../images/loading.gif')}
                  src={require('../../images/02.jpg')}
                  style={{
                    position: 'relative'
                  }}
                />
              </span>
            }
            position='bottom'
            size='small'
            arrow
            trigger='click'
            style={{
              position: 'absolute',
              zIndex: '99999',
              top: '34.5%',
              left: '46.6%'
            }}
            className={this.state.activeHighlight === 2 ? 'active' : 'inactive'}
            onShown={() => this.setActiveHighlight(2)}
            onHide={() => this.setActiveHighlight(-1)}
          >
            <div className='highlight' style={{ zIndex: '9' }} />
          </Tooltip>

          <Tooltip
            html={
              <span>
                <h3>Arnold Huggler</h3>
                <h2>Wasserträger</h2>
                <p>
                  <i className='bullseye icon' />
                  Scheuchzerstr. 190
                </p>
                <Img
                  placeholder={require('../../images/loading.gif')}
                  src={require('../../images/03.jpg')}
                  style={{
                    position: 'relative'
                  }}
                />
              </span>
            }
            position='bottom'
            size='small'
            arrow
            trigger='click'
            style={{
              position: 'absolute',
              zIndex: '99999',
              top: '35.5%',
              left: '52%'
            }}
            className={this.state.activeHighlight === 3 ? 'active' : 'inactive'}
            onShown={() => this.setActiveHighlight(3)}
            onHide={() => this.setActiveHighlight(-1)}
          >
            <div className='highlight' style={{ zIndex: '9' }} />
          </Tooltip>

          <Tooltip
            html={
              <span>
                <h3>Louis Conne</h3>
                <h2>Ruhender, nackter Mann</h2>
                <p>
                  <i className='bullseye icon' />
                  Freibad Letzigraben
                </p>
                <Img
                  placeholder={require('../../images/loading.gif')}
                  src={require('../../images/04.jpg')}
                  style={{
                    position: 'relative'
                  }}
                />
              </span>
            }
            position='bottom'
            size='small'
            arrow
            trigger='click'
            style={{
              position: 'absolute',
              zIndex: '99999',
              top: '45.3%',
              left: '31.3%'
            }}
            className={this.state.activeHighlight === 4 ? 'active' : 'inactive'}
            onShown={() => this.setActiveHighlight(4)}
            onHide={() => this.setActiveHighlight(-1)}
          >
            <div className='highlight' style={{ zIndex: '9' }} />
          </Tooltip>

          <Tooltip
            html={
              <span>
                <h3>Otto Kappeler</h3>
                <h2>Vier sitzende Jünglinge</h2>
                <p>
                  <i className='bullseye icon' />
                  Klingenpark
                </p>
                <Img
                  placeholder={require('../../images/loading.gif')}
                  src={require('../../images/05.jpg')}
                  style={{
                    position: 'relative'
                  }}
                />
              </span>
            }
            position='bottom'
            size='small'
            arrow
            trigger='click'
            style={{
              position: 'absolute',
              zIndex: '99999',
              top: '45.8%',
              left: '44%'
            }}
            className={this.state.activeHighlight === 5 ? 'active' : 'inactive'}
            onShown={() => this.setActiveHighlight(5)}
            onHide={() => this.setActiveHighlight(-1)}
          >
            <div className='highlight' style={{ zIndex: '9' }} />
          </Tooltip>

          <Tooltip
            html={
              <span>
                <h3>Julius Schwyzer</h3>
                <h2>Liegender Mann</h2>
                <p>
                  <i className='bullseye icon' />
                  Bahnhof Wiedikon
                </p>
                <Img
                  placeholder={require('../../images/loading.gif')}
                  src={require('../../images/06.jpg')}
                  style={{
                    position: 'relative'
                  }}
                />
              </span>
            }
            position='bottom'
            size='small'
            arrow
            trigger='click'
            style={{
              position: 'absolute',
              zIndex: '99999',
              top: '49.7%',
              left: '38.7%'
            }}
            className={this.state.activeHighlight === 6 ? 'active' : 'inactive'}
            onShown={() => this.setActiveHighlight(6)}
            onHide={() => this.setActiveHighlight(-1)}
          >
            <div className='highlight' style={{ zIndex: '9' }} />
          </Tooltip>

          <Tooltip
            html={
              <span>
                <h3>Hermann Feuerhahn</h3>
                <h2>Mann mit Kentaur</h2>
                <p>
                  <i className='bullseye icon' />
                  Kasernenareal
                </p>
                <Img
                  placeholder={require('../../images/loading.gif')}
                  src={require('../../images/07.jpg')}
                  style={{
                    position: 'relative'
                  }}
                />
              </span>
            }
            position='bottom'
            size='small'
            arrow
            trigger='click'
            style={{
              position: 'absolute',
              zIndex: '99999',
              top: '49%',
              left: '44%'
            }}
            className={this.state.activeHighlight === 7 ? 'active' : 'inactive'}
            onShown={() => this.setActiveHighlight(7)}
            onHide={() => this.setActiveHighlight(-1)}
          >
            <div className='highlight' style={{ zIndex: '9' }} />
          </Tooltip>

          <Tooltip
            html={
              <span>
                <h3>Max Soldenhoff</h3>
                <h2>Zwei Paare</h2>
                <p>
                  <i className='bullseye icon' />
                  Sportanlage Sihlhölzli
                </p>
                <Img
                  placeholder={require('../../images/loading.gif')}
                  src={require('../../images/08.jpg')}
                  style={{
                    position: 'relative'
                  }}
                />
              </span>
            }
            position='bottom'
            size='small'
            arrow
            trigger='click'
            style={{
              position: 'absolute',
              zIndex: '99999',
              top: '52.7%',
              left: '37.4%'
            }}
            className={this.state.activeHighlight === 8 ? 'active' : 'inactive'}
            onShown={() => this.setActiveHighlight(8)}
            onHide={() => this.setActiveHighlight(-1)}
          >
            <div className='highlight' style={{ zIndex: '9' }} />
          </Tooltip>

          <Tooltip
            html={
              <span>
                <h3>Jakob Brüllmann</h3>
                <h2>Geiserbrunnen</h2>
                <p>
                  <i className='bullseye icon' />
                  Bürkliplatz
                </p>
                <Img
                  placeholder={require('../../images/loading.gif')}
                  src={require('../../images/09.jpg')}
                  style={{
                    position: 'relative'
                  }}
                />
              </span>
            }
            position='bottom'
            size='small'
            arrow
            trigger='click'
            style={{
              position: 'absolute',
              zIndex: '99999',
              top: '51.4%',
              left: '49.4%'
            }}
            className={this.state.activeHighlight === 9 ? 'active' : 'inactive'}
            onShown={() => this.setActiveHighlight(9)}
            onHide={() => this.setActiveHighlight(-1)}
          >
            <div className='highlight' style={{ zIndex: '9' }} />
          </Tooltip>

          <Tooltip
            html={
              <span>
                <h3>Otto Charles Bänninger</h3>
                <h2>Der Genesende</h2>
                <p>
                  <i className='bullseye icon' />
                  Unispital Zürich
                </p>
                <Img
                  placeholder={require('../../images/loading.gif')}
                  src={require('../../images/10.jpg')}
                  style={{
                    position: 'relative'
                  }}
                />
              </span>
            }
            position='bottom'
            size='small'
            arrow
            trigger='click'
            style={{
              position: 'absolute',
              zIndex: '99999',
              top: '47.7%',
              left: '56.2%'
            }}
            className={
              this.state.activeHighlight === 10 ? 'active' : 'inactive'
            }
            onShown={() => this.setActiveHighlight(10)}
            onHide={() => this.setActiveHighlight(-1)}
          >
            <div className='highlight' style={{ zIndex: '9' }} />
          </Tooltip>

          <Tooltip
            html={
              <span>
                <h3>Hermann Haller</h3>
                <h2>Zwei liegende Figuren</h2>
                <p>
                  <i className='bullseye icon' />
                  Hauptgebäude Universität
                </p>
                <Img
                  placeholder={require('../../images/loading.gif')}
                  src={require('../../images/11.jpg')}
                  style={{
                    position: 'relative'
                  }}
                />
              </span>
            }
            position='bottom'
            size='small'
            arrow
            trigger='click'
            style={{
              position: 'absolute',
              zIndex: '99999',
              top: '49.1%',
              left: '56%'
            }}
            className={
              this.state.activeHighlight === 11 ? 'active' : 'inactive'
            }
            onShown={() => this.setActiveHighlight(11)}
            onHide={() => this.setActiveHighlight(-1)}
          >
            <div className='highlight' style={{ zIndex: '9' }} />
          </Tooltip>

          <Tooltip
            html={
              <span>
                <h3>August Suter</h3>
                <h2>Orpheus</h2>
                <p>
                  <i className='bullseye icon' />
                  Kirche Fluntern
                </p>
                <Img
                  placeholder={require('../../images/loading.gif')}
                  src={require('../../images/12.jpg')}
                  style={{
                    position: 'relative'
                  }}
                />
              </span>
            }
            position='bottom'
            size='small'
            arrow
            trigger='click'
            style={{
              position: 'absolute',
              zIndex: '99999',
              top: '47.1%',
              left: '61.4%'
            }}
            className={
              this.state.activeHighlight === 12 ? 'active' : 'inactive'
            }
            onShown={() => this.setActiveHighlight(12)}
            onHide={() => this.setActiveHighlight(-1)}
          >
            <div className='highlight' style={{ zIndex: '9' }} />
          </Tooltip>

          <Tooltip
            html={
              <span>
                <h3>Flora Steiger-Crawford</h3>
                <h2>Bruno, stehend</h2>
                <p>
                  <i className='bullseye icon' />
                  Zugang Bürohaus, bei Hofstr. 1
                </p>
              </span>
            }
            position='bottom'
            size='small'
            arrow
            trigger='click'
            style={{
              position: 'absolute',
              zIndex: '99999',
              top: '50.5%',
              left: '61.35%'
            }}
            className={
              this.state.activeHighlight === 13 ? 'active' : 'inactive'
            }
            onShown={() => this.setActiveHighlight(13)}
            onHide={() => this.setActiveHighlight(-1)}
          >
            <div className='highlight' style={{ zIndex: '9' }} />
          </Tooltip>

          <Tooltip
            html={
              <span>
                <h3>Hermann Hubacher</h3>
                <h2>Ganymed</h2>
                <p>
                  <i className='bullseye icon' />
                  Bürkli-Terrasse
                </p>
                <Img
                  placeholder={require('../../images/loading.gif')}
                  src={require('../../images/14.jpg')}
                  style={{
                    position: 'relative'
                  }}
                />
              </span>
            }
            position='bottom'
            size='small'
            arrow
            trigger='click'
            style={{
              position: 'absolute',
              zIndex: '99999',
              top: '52.9%',
              left: '50.4%'
            }}
            className={
              this.state.activeHighlight === 14 ? 'active' : 'inactive'
            }
            onShown={() => this.setActiveHighlight(14)}
            onHide={() => this.setActiveHighlight(-1)}
          >
            <div className='highlight' style={{ zIndex: '9' }} />
          </Tooltip>

          <Tooltip
            html={
              <span>
                <h3>Richard Kissling</h3>
                <h2>Jüngling mit Hund</h2>
                <p>
                  <i className='bullseye icon' />
                  Vorplatz Villa Tobler
                </p>
                <Img
                  placeholder={require('../../images/loading.gif')}
                  src={require('../../images/15.jpg')}
                  style={{
                    position: 'relative'
                  }}
                />
              </span>
            }
            position='bottom'
            size='small'
            arrow
            trigger='click'
            style={{
              position: 'absolute',
              zIndex: '99999',
              top: '50.8%',
              left: '55.8%'
            }}
            className={
              this.state.activeHighlight === 15 ? 'active' : 'inactive'
            }
            onShown={() => this.setActiveHighlight(15)}
            onHide={() => this.setActiveHighlight(-1)}
          >
            <div className='highlight' style={{ zIndex: '9' }} />
          </Tooltip>

          <Tooltip
            html={
              <span>
                <h3>Ivar Johnsson</h3>
                <h2>David, Seepromenade</h2>
                <p>
                  <i className='bullseye icon' />
                  Bei Theaterplatz 1
                </p>
                <Img
                  placeholder={require('../../images/loading.gif')}
                  src={require('../../images/16.jpg')}
                  style={{
                    position: 'relative'
                  }}
                />
              </span>
            }
            position='bottom'
            size='small'
            arrow
            trigger='click'
            style={{
              position: 'absolute',
              zIndex: '99999',
              top: '52.9%',
              left: '56%'
            }}
            className={
              this.state.activeHighlight === 16 ? 'active' : 'inactive'
            }
            onShown={() => this.setActiveHighlight(16)}
            onHide={() => this.setActiveHighlight(-1)}
          >
            <div className='highlight' style={{ zIndex: '9' }} />
          </Tooltip>

          <Tooltip
            html={
              <span>
                <h3>Hermann Haller</h3>
                <h2>Jüngling</h2>
                <p>
                  <i className='bullseye icon' />
                  Grünanlage Artergut
                </p>
                <Img
                  placeholder={require('../../images/loading.gif')}
                  src={require('../../images/17.jpg')}
                  style={{
                    position: 'relative'
                  }}
                />
              </span>
            }
            position='bottom'
            size='small'
            arrow
            trigger='click'
            style={{
              position: 'absolute',
              zIndex: '99999',
              top: '52.8%',
              left: '61.3%'
            }}
            className={
              this.state.activeHighlight === 17 ? 'active' : 'inactive'
            }
            onShown={() => this.setActiveHighlight(17)}
            onHide={() => this.setActiveHighlight(-1)}
          >
            <div className='highlight' style={{ zIndex: '9' }} />
          </Tooltip>

          <Tooltip
            html={
              <span>
                <h3>Eduard Bick</h3>
                <h2>Jüngling</h2>
                <p>
                  <i className='bullseye icon' />
                  Grünanlage Sonnenberg
                </p>
                <Img
                  placeholder={require('../../images/loading.gif')}
                  src={require('../../images/18.jpg')}
                  style={{
                    position: 'relative'
                  }}
                />
              </span>
            }
            position='bottom'
            size='small'
            arrow
            trigger='click'
            style={{
              position: 'absolute',
              zIndex: '99999',
              top: '53.2%',
              left: '67.2%'
            }}
            className={
              this.state.activeHighlight === 18 ? 'active' : 'inactive'
            }
            onShown={() => this.setActiveHighlight(18)}
            onHide={() => this.setActiveHighlight(-1)}
          >
            <div className='highlight' style={{ zIndex: '9' }} />
          </Tooltip>

          <Tooltip
            html={
              <span>
                <h3>Werner Friedrich Kunz</h3>
                <h2>Mann mit Habicht</h2>
                <p>
                  <i className='bullseye icon' />
                  Rieterpark
                </p>
                <Img
                  placeholder={require('../../images/loading.gif')}
                  src={require('../../images/19.jpg')}
                  style={{
                    position: 'relative'
                  }}
                />
              </span>
            }
            position='bottom'
            size='small'
            arrow
            trigger='click'
            style={{
              position: 'absolute',
              zIndex: '99999',
              top: '55.5%',
              left: '45.2%'
            }}
            className={
              this.state.activeHighlight === 19 ? 'active' : 'inactive'
            }
            onShown={() => this.setActiveHighlight(19)}
            onHide={() => this.setActiveHighlight(-1)}
          >
            <div className='highlight' style={{ zIndex: '9' }} />
          </Tooltip>

          <Tooltip
            html={
              <span>
                <h3>Karl Geiser</h3>
                <h2>Schreitender (Franz)</h2>
                <p>
                  <i className='bullseye icon' />
                  Muraltengut, bei Seestr. 203
                </p>
                <Img
                  placeholder={require('../../images/loading.gif')}
                  src={require('../../images/20.jpg')}
                  style={{
                    position: 'relative'
                  }}
                />
              </span>
            }
            position='bottom'
            size='small'
            arrow
            trigger='click'
            style={{
              position: 'absolute',
              zIndex: '99999',
              top: '57.8%',
              left: '47.5%'
            }}
            className={
              this.state.activeHighlight === 20 ? 'active' : 'inactive'
            }
            onShown={() => this.setActiveHighlight(20)}
            onHide={() => this.setActiveHighlight(-1)}
          >
            <div className='highlight' style={{ zIndex: '9' }} />
          </Tooltip>
          <div className='source'>Karte: Bobi Bazooka</div>
        </div>
      </div>
    )
  }
}
